<template>  
    <div>  
        <!--loader - message--->
        <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
		<div class="stepForm" v-if="success == '3'">
            <div class="mainTitle text-center mt-4 mb-3"> 
                <h3 class="mb-4">{{$t('toolVps_reqProcessing')}}</h3>
            </div> 
           
        </div>
        <div class="stepForm" v-if="success == true">
            <div class="mainTitle text-center mt-4 mb-3"> 
                <h3 class="mb-4"> {{$t('toolVps_reqVerify')}}</h3>
            </div> 
            <div class="CustomBlockWidth inMiddle-area whitebox p-4">   
                <div class="congratulations">
                    <div class="logo_congrats">
                        <img src="../../../../../static/fxView/images/check.svg" alt="request verify">
                    </div>
                    <div class="subtitle">
                        <h3>{{$t('verf_dear')}} <span class="green">{{get_user.username}}</span></h3>
                        <p>{{$t('toolVps_verifySubscribe')}}</p> 
                    </div>
                    <div class="signupbtn full-width submitButton w-100 mt-4 text-center">
                        <router-link to="/tools/VPS" class="prism_btn btn_sm">{{$t('toolVps_back_subList')}}</router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="stepForm" v-if="success == false">
            <div class="mainTitle text-center mt-4 mb-3"> 
                <h3 class="mb-4"> {{$t('reqFailed')}}</h3>
            </div> 
            <div class="CustomBlockWidth inMiddle-area whitebox p-4">   
                <div class="congratulations">
                    <div class="logo_congrats">
                        <img src="../../../../../static/fxView/images/cross.svg" alt="request failed">
                    </div>
                    <div class="subtitle">
                        <h3> {{$t('verf_dear')}}<span class="green">{{get_user.username}}</span> </h3>
                        <p>{{msg}}</p> 
                    </div>
                    <div class="signupbtn full-width submitButton w-100 mt-4 text-center">
                        <router-link to="/tools/VPS" class="prism_btn btn_sm">{{$t('toolVps_back_subList')}}</router-link>
                    </div>
                </div>
            </div> 
        </div>
    </div> 
</template>
<script>
    export default {
        name: 'Withdrawal',
        data() {
            return {
               verify : '',
               success : '3',
               msg : '',
               pageLoader : false,
                response_msg : '',
                msg_type : '',
            }
        },
        created(){
            let query = Object.assign({}, this.$route.query);
            if(this.$route.query.verify){
                this.verify = query.verify
                let input_json = {
                    'globalParams' : {
                        'verify' : this.verify.toString()
                    } ,'localParams' : {'parameter' : this , 'params' :'request-verify'}
                }
                this._runSubscriptionCheckOtp(input_json)
                delete query.verify;
                this.$router.replace({ query });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/tools/pages/sub_change_account_verify.vue